"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WWW_DOT_SNAPCHAT_DOT_COM_GA = void 0;
/**
 * Universal Analytics uses a tracking ID of the format UA-XXXXXX-xx. The first set of numbers
 * (i.e 41740027 in this case) refers to the account number, and the second set (74) the specific
 * property.
 * Google Analytics 4 measurement IDs start with "G-".
 */
/* istanbul ignore next - constants */
const ACCOUNT = "41740027";
/* istanbul ignore next - constants */
exports.WWW_DOT_SNAPCHAT_DOT_COM_GA = {
    UAId: `UA-${ACCOUNT}-1}`,
    measurementId: "G-DPDHJB4310",
};
//# sourceMappingURL=index.js.map